/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Faq_Customize_QuestionInputs */

const en_landing_faq_customize_question = /** @type {(inputs: Landing_Faq_Customize_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How customizable is the landing page?`)
};

const zh_landing_faq_customize_question = /** @type {(inputs: Landing_Faq_Customize_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`落地页可以自定义到什么程度？`)
};

/**
* | output |
* | --- |
* | "How customizable is the landing page?" |
*
* @param {Landing_Faq_Customize_QuestionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_faq_customize_question = /** @type {((inputs?: Landing_Faq_Customize_QuestionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Faq_Customize_QuestionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_faq_customize_question(inputs)
	return zh_landing_faq_customize_question(inputs)
});
export { landing_faq_customize_question as "landing.faq.customize.question" }